// src/components/common/PreferencesModal.js

import React, { useState } from 'react';
import { usePreferences } from '../../context/PreferencesContext'; // Corrected path
import './PreferencesModal.css'; // Ensure this file exists

const PreferencesModal = ({ onClose }) => {
  const { state, dispatch } = usePreferences();

  // Local state for comedic style and topics
  const [comedicStyle, setComedicStyle] = useState(state.comedicStyle);
  const [topics, setTopics] = useState(state.topics);

  // New local states for additional questions
  const [performancePreferences, setPerformancePreferences] = useState({
    improvisation: false,
    crowdWork: false,
    storytelling: false,
    oneLiners: false,
    observational: false,
  });

  const [audienceTypes, setAudienceTypes] = useState({
    familyFriendly: false,
    adultOnly: false,
    corporate: false,
    collegeCrowd: false,
  });

  // Handle saving the preferences
  const handleSave = () => {
    dispatch({ type: 'SET_STYLE', payload: comedicStyle });
    dispatch({ type: 'SET_TOPICS', payload: topics });

    // Log the data to the console
    console.log({
      comedicStyle,
      topics,
      performancePreferences,
      audienceTypes,
    });

    onClose(); // Close the modal
  };

  // Handle checkbox changes
  const handleTopicChange = (e) => {
    const { value, checked } = e.target;
    setTopics((prev) =>
      checked ? [...prev, value] : prev.filter((topic) => topic !== value)
    );
  };

  const handlePerformanceChange = (e) => {
    const { name, checked } = e.target;
    setPerformancePreferences((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleAudienceChange = (e) => {
    const { name, checked } = e.target;
    setAudienceTypes((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  return (
    <div className="preferences-modal-overlay" onDoubleClick={onClose}>
      <div className="preferences-modal" onClick={(e) => e.stopPropagation()}>
        <h2>User Preferences</h2>

        {/* Comedic Style Dropdown */}
        <label>Comedic Style:</label>
        <select
          value={comedicStyle}
          onChange={(e) => setComedicStyle(e.target.value)}
        >
          <option value="clean">Clean</option>
          <option value="average">Average</option>
          <option value="dirty">Dirty</option>
        </select>

        {/* Topics Section */}
        <div className="preferences-section">
          <h3>Topics (select multiple):</h3>
          <label>
            <input
              type="checkbox"
              value="Politics"
              checked={topics.includes('Politics')}
              onChange={handleTopicChange}
            />
            Politics
          </label>
          <label>
            <input
              type="checkbox"
              value="Relationships"
              checked={topics.includes('Relationships')}
              onChange={handleTopicChange}
            />
            Relationships
          </label>
          <label>
            <input
              type="checkbox"
              value="Pop Culture"
              checked={topics.includes('Pop Culture')}
              onChange={handleTopicChange}
            />
            Pop Culture
          </label>
          <label>
            <input
              type="checkbox"
              value="Self-Deprecating"
              checked={topics.includes('Self-Deprecating')}
              onChange={handleTopicChange}
            />
            Self-Deprecating
          </label>
          <label>
            <input
              type="checkbox"
              value="Current Events"
              checked={topics.includes('Current Events')}
              onChange={handleTopicChange}
            />
            Current Events
          </label>
        </div>

        {/* Performance Preferences Section */}
        <div className="preferences-section">
          <h3>Performance Preferences:</h3>
          <label>
            <input
              type="checkbox"
              name="improvisation"
              checked={performancePreferences.improvisation}
              onChange={handlePerformanceChange}
            />
            Improvisation
          </label>
          <label>
            <input
              type="checkbox"
              name="crowdWork"
              checked={performancePreferences.crowdWork}
              onChange={handlePerformanceChange}
            />
            Crowd Work
          </label>
          <label>
            <input
              type="checkbox"
              name="storytelling"
              checked={performancePreferences.storytelling}
              onChange={handlePerformanceChange}
            />
            Storytelling
          </label>
          <label>
            <input
              type="checkbox"
              name="oneLiners"
              checked={performancePreferences.oneLiners}
              onChange={handlePerformanceChange}
            />
            One-liners
          </label>
          <label>
            <input
              type="checkbox"
              name="observational"
              checked={performancePreferences.observational}
              onChange={handlePerformanceChange}
            />
            Observational Comedy
          </label>
        </div>

        {/* Audience Type Preferences Section */}
        <div className="preferences-section">
          <h3>Audience Types:</h3>
          <label>
            <input
              type="checkbox"
              name="familyFriendly"
              checked={audienceTypes.familyFriendly}
              onChange={handleAudienceChange}
            />
            Family Friendly
          </label>
          <label>
            <input
              type="checkbox"
              name="adultOnly"
              checked={audienceTypes.adultOnly}
              onChange={handleAudienceChange}
            />
            Adult Only
          </label>
          <label>
            <input
              type="checkbox"
              name="corporate"
              checked={audienceTypes.corporate}
              onChange={handleAudienceChange}
            />
            Corporate Events
          </label>
          <label>
            <input
              type="checkbox"
              name="collegeCrowd"
              checked={audienceTypes.collegeCrowd}
              onChange={handleAudienceChange}
            />
            College Crowd
          </label>
        </div>

        {/* Save/Cancel Buttons */}
        <button onClick={handleSave}>Save Preferences</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default PreferencesModal;
